var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.5C9.67158 1.5 9 2.17158 9 3V4.5H7.5C5.01472 4.5 3 6.51473 3 9V30C3 32.4853 5.01472 34.5 7.5 34.5H19.6515C18.7726 33.6389 18.0445 32.6244 17.5104 31.5H7.5C6.67158 31.5 6 30.8284 6 30V16.5H30V16.9348C31.0836 17.2573 32.094 17.7501 33 18.382V9C33 6.51473 30.9853 4.5 28.5 4.5H27V3C27 2.17158 26.3284 1.5 25.5 1.5C24.6715 1.5 24 2.17158 24 3V4.5H12V3C12 2.17158 11.3284 1.5 10.5 1.5ZM24 9V7.5H12V9C12 9.82842 11.3284 10.5 10.5 10.5C9.67158 10.5 9 9.82842 9 9V7.5H7.5C6.67158 7.5 6 8.17158 6 9V13.5H30V9C30 8.17158 29.3284 7.5 28.5 7.5H27V9C27 9.82842 26.3284 10.5 25.5 10.5C24.6715 10.5 24 9.82842 24 9Z",
    fill: "#22A873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 24C25.5 23.1716 26.1716 22.5 27 22.5C27.8284 22.5 28.5 23.1716 28.5 24V26.5545L29.8202 27.8745C30.4059 28.4604 30.4059 29.41 29.8202 29.9959C29.2344 30.5817 28.2846 30.5817 27.6989 29.9959L25.9394 28.2365C25.6242 27.9213 25.4785 27.5007 25.5025 27.0882C25.5009 27.0589 25.5 27.0296 25.5 27V24Z",
    fill: "#22A873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 27C36 31.9705 31.9705 36 27 36C22.0294 36 18 31.9705 18 27C18 22.0294 22.0294 18 27 18C31.9705 18 36 22.0294 36 27ZM20.9729 27C20.9729 30.3286 23.6714 33.0272 27 33.0272C30.3286 33.0272 33.0272 30.3286 33.0272 27C33.0272 23.6714 30.3286 20.9729 27 20.9729C23.6714 20.9729 20.9729 23.6714 20.9729 27Z",
    fill: "#22A873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleLink);
export default __webpack_public_path__ + "static/media/scheduleLink.1993e28d788fddc18b1ea18efe372bd3.svg";
export { ForwardRef as ReactComponent };